export const initBackgroundVideos = () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-background-video]').forEach((video) => {
    let inView = false;
    let loaded = false;

    const update = () => {
      const mayPlay = inView && !document.hidden
        && !reduceMotion.matches && !navigator.connection?.saveData;
      if (!mayPlay) {
        video.pause();
        return;
      }
      if (!loaded) {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        video.load();
        loaded = true;
      }
      video.play().catch(() => null);
    };

    document.addEventListener('visibilitychange', update);
    reduceMotion.addEventListener('change', update);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        update();
      });
      observer.observe(video);
    } else {
      inView = true;
      update();
    }
  });
};
